/**
 * Created by andreyna on 7/30/2017.
 */
import BaseService from '../../base/base_service';
import Event from '../../utils/event';
import {SYSTEM_EVENTS} from '../../events/events';
import DOM from '../../utils/dom';
import FreePlayComponent from '../../components/free_play/free_play_component_controller';
import ScrollableContainerComponent from '../../components/scrollable_container/scrollable_container_controller';
import TouchIDComponentController
    from '../../components/options/option_components/touch_id/touch_id_component_controller';


class ComponentTesterService extends BaseService {
    /**
     * @static
     * @type {string}
     */
    static CLASS = 'ComponentTesterService';

    /**
     * Factory method for creation components by name
     * @param componentName
     * @private
     */
    componentCreateMapper = {
        'fp': {
            create: (params) => {
                return FreePlayComponent.create(params);
            }
        },
        'scroll': {
            create: (params) => {
                let createHTMLElements = (count) => {
                    let elements = [];
                    for (let i = 0; i < count; i++) {
                        elements.push(DOM.createElement('div',
                            `<div style="width: 100px;height: 100px;background: yellow;">DIV${i}</div>`));
                    }
                    return elements;
                };
                return ScrollableContainerComponent.create(Object.assign({}, params, {
                    items: createHTMLElements(20),
                    arrowsPadding: [30, 20, 30, 20],
                    itemGap: 5,
                    scrollingStep: 1,
                    //scrollingDuration: 1000,
                    // grid: {
                    //     itemsInRow: 5,
                    //     gap: 10
                    // },
                    // direction: 'vertical'
                }));
            }
        },
        'touch_id': {
            create: (params) => {
                return TouchIDComponentController.create(params);
            },
            skipOverlay: true
        }
    }

    /**
     *
     * @param params
     */
    init(params) {
        super.init(params);
    }


    /**
     * Create component by name and open it on Overlay
     * @param componentName
     */
    openComponentOnOverlay(componentName, params) {

        const componentMapper = this.componentCreateMapper[componentName];

        const component = componentMapper.create(params);
        component.start();

        if(!componentMapper.skipOverlay) {
            Event.fire(SYSTEM_EVENTS.OPEN_OVERLAY, {
                component,
                // el: component.getEl(),
                priority: this.componentCreateMapper[componentName].priority,
                isCloseBtnAllowed: true,
                isHasHeader: false,
                // additionalClasses: ['cgp-fp-vouchers-msg-dialog'],
                // contentAdditionalClasses: ['cgp-theme-property-corner-radius', 'cgp-theme-property-border-size', 'cgp-theme-property-border-color-secondary'],
                // openCallback: () => {
                //     component.onAppendedToDOM();
                //     //component.scrollTo(5);
                //      //component.setStyle({arrowsPadding: [40, 30], direction: 'vertical', itemGap: 10});
                //     },
                // closeCallback: () => {
                //     //this.shutDown();
                // }
            });
        }
    }
}

export default ComponentTesterService;